// Search helpers for the Contacts and Accounts list search boxes.
// Typed text is trimmed because a phone's trailing space used to match nothing.

/** The text to look for, trimmed and lower case, with '' meaning no search. */
export function searchNeedle(q) {
  return String(q ?? '').trim().toLowerCase();
}

/** True when there is no search or any text value contains it. */
export function matchesSearch(needle, values) {
  if (!needle) return true;
  return (values || []).some((v) => typeof v === 'string' && v.toLowerCase().includes(needle));
}
